// src/config/api.js
// Fonte única da URL base da API.
// - Produção: usa caminho relativo '/backend/api' (mesmo domínio, sem precisar de .env).
// - Desenvolvimento: defina REACT_APP_API_URL em frontend/.env.development
//   (ex.: REACT_APP_API_URL=http://localhost:8000/api) para sobrescrever.
const API_URL = process.env.REACT_APP_API_URL || '/backend/api';

export default API_URL;
